import {useEffect, useRef} from "react";

const EVENTS = new Set(["mock_discovery_view", "mock_discovery_click", "mock_catalogue_view", "mock_starter_view", "mock_starter_click", "mock_continue_view", "mock_continue_click", "mock_start", "mock_complete", "mock_results_view"]);
const SOURCES = new Set(["homepage", "navigation", "guest_landing", "typing_result", "starter_card", "continue_card", "catalogue", "practice"]);

export function trackMockFunnel(event, details = {}) {
  if (!EVENTS.has(event)) return false;
  try {
    const consent = JSON.parse(localStorage.getItem("typogram_cookie_consent") || "null");
    if (consent?.preferences?.analytics !== true || typeof window.gtag !== "function") return false;
    const params = {product:"exam_mocks"};
    if (SOURCES.has(details.source)) params.source = details.source;
    if (["review_result", "practice_mistakes", "next_mock", "choose_mock"].includes(details.action)) params.action = details.action;
    // Do not send names, email addresses, responses, or arbitrary caller metadata.
    for (const key of ["paper_id", "question_count", "time_taken_seconds"]) {
      const value = Number(details[key]);
      if (details[key] != null && Number.isFinite(value) && value >= 0) params[key] = value;
    }
    for (const key of ["starter", "reattempt", "auto_submitted"]) {
      if (typeof details[key] === "boolean") params[key] = details[key];
    }
    window.gtag("event", event, params);
    return true;
  } catch {return false;}
}

// Track an impression only after the actual card enters the viewport.
export function useMockFunnelImpression(event, details, identity = "default") {
  const ref = useRef(null);
  const seen = useRef(new Set());
  const latest = useRef(details);
  latest.current = details;
  useEffect(() => {
    const node = ref.current;
    if (!node || seen.current.has(identity) || typeof IntersectionObserver === "undefined") return;
    let visible = false;
    const send = () => {
      if (!visible || seen.current.has(identity)) return;
      if (trackMockFunnel(event, latest.current)) {
        seen.current.add(identity);
        observer.disconnect();
      }
    };
    const observer = new IntersectionObserver(entries => {
      visible = entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= 0.25);
      send();
    }, {threshold:0.25});
    observer.observe(node);
    window.addEventListener("typogram:consent-changed", send);
    return () => {
      observer.disconnect();
      window.removeEventListener("typogram:consent-changed", send);
    };
  }, [event, identity]);
  return ref;
}
